"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const faCompress_1 = require("@fortawesome/free-solid-svg-icons/faCompress");
const faExpand_1 = require("@fortawesome/free-solid-svg-icons/faExpand");
const react_ui_1 = require("@yanzi/react-ui");
const hooks_1 = require("../hooks");
const Fullscreen = (_a) => {
    var { onClick } = _a, rest = __rest(_a, ["onClick"]);
    const isFullscreen = hooks_1.useFullscreen();
    return (jsx_runtime_1.jsx(react_ui_1.FloatingActionButton, Object.assign({}, rest, { label: isFullscreen ? 'Exit fullscreen mode' : 'Fullscreen', onClick: () => onClick(!isFullscreen), icon: isFullscreen ? faCompress_1.faCompress : faExpand_1.faExpand }), void 0));
};
exports.default = Fullscreen;
//# sourceMappingURL=Fullscreen.js.map